import { colors } from 'bold-ui'
import { DirtyFieldsModalConfig, ValidationErrorModalConfig } from 'components/modals/fields-summary'
import { isUndefinedOrNull } from 'util/checks'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'

export const soapValidationErrorModalConfig: ValidationErrorModalConfig<SoapState> = {
  subjetivo: {
    titleColor: colors.pink.c40,
  },
  objetivo: {
    titleColor: colors.blue.c50,
    fields: {
      atendimentosEspecificos: {
        hideLabelOnModal: true,
        fields: {
          puericultura: {
            fields: {
              alteracoesFenotipicas: { hideChildrenOnModal: true },
              fatoresRisco: { hideChildrenOnModal: true },
              marcosDesenvolvimento: { hideChildrenOnModal: true },
            },
          },
        },
      },
      marcadoresConsumoAlimentar: {
        hideChildrenOnModal: true,
      },
      anexoArquivos: {
        hideChildrenOnModal: true,
      },
    },
  },
  avaliacao: {
    titleColor: colors.yellow.c40,
  },
  plano: {
    titleColor: colors.green.c40,
    fields: {
      intervencoesProcedimentos: {
        fields: {
          procedimentosPlano: { hideChildrenOnModal: true },
        },
      },
      odontologia: {
        fields: {
          periodontia: {
            fields: {
              periogramaCompleto: {
                hideLabelOnModal: (error) => isUndefinedOrNull(error.observacao),
                fields: {
                  dados: {
                    hideChildrenOnModal: true,
                  },
                },
              },
            },
          },
        },
      },
    },
  },
  preNatal: {
    titleColor: colors.purple.c60,
  },
}

export const dirtyFieldsModalConfig: DirtyFieldsModalConfig<SoapState> = {
  subjetivo: {
    titleColor: colors.pink.c40,
  },
  objetivo: {
    titleColor: colors.blue.c50,
    fields: {
      atendimentosEspecificos: {
        hideLabelOnModal: true,
        fields: {
          ivcf: {
            hideChildrenOnModal: true,
          },
        },
      },
      medicoes: {
        hideChildrenOnModal: true,
      },
      marcadoresConsumoAlimentar: {
        hideChildrenOnModal: true,
      },
    },
  },
  plano: {
    titleColor: colors.green.c40,
    fields: {
      intervencoesProcedimentos: {
        hideLabelOnModal: true,
        fields: {
          procedimentosPlano: { hideChildrenOnModal: true },
          ciaps: { hideChildrenOnModal: true },
        },
      },
      orientacao: {
        hideChildrenOnModal: true,
      },
    },
  },
  finalizacao: {
    fields: {
      procedimentosAdministrativos: { hideChildrenOnModal: true },
      fichasNotificacaoCasoSuspeito: { hideChildrenOnModal: true },
      racionalidadeEmSaude: { hideChildrenOnModal: true },
    },
  },
  medicoesAnteriores: {
    showNoFieldsPlaceholder: true,
  },
}
